// extracted by mini-css-extract-plugin
module.exports = {"lnkAccess":"reportsList_lnkAccess__33Y6k"};